import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconUser = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M12 12a5 5 0 1 1 0-10 5 5 0 0 1 0 10" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.399 13c3.101 2.5 6.101 2.5 9.266.01 2.721.407 4.335 1.483 4.335 3.337v4.232c-6.3 1.895-11.7 1.895-18 0v-4.232C3 14.478 4.639 13.4 7.399 13"
      clipRule="evenodd"
    />
  </NcIcon>
);
export { NcIconUser };
